<together-auction-dip-loading [is_loading]="isLoading"></together-auction-dip-loading>
